import { apiService } from './api';

export interface SystemSettings {
  systemName: string;
  logoUrl: string;
}

class SettingsService {
  async get(): Promise<SystemSettings> {
    const res = await apiService.get<{ settings: SystemSettings }>(`/settings`);
    return res.settings;
  }

  async update(payload: Partial<SystemSettings>): Promise<SystemSettings> {
    const res = await apiService.put<{ message: string; settings: SystemSettings }>(`/settings`, payload);
    return res.settings;
  }
}

export const settingsService = new SettingsService();

